<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-container>
  <div mat-dialog-title>
    @if(!data.citeDuty?.id) {
    New CITE Duty
    } @else {
    Edit CITE Duty
    }
    @if(data.citeDuty?.isTemplate) {
    Template
    }
    &nbsp;
    <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (data && data.citeDuty) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="data.citeDuty.name" />
        </mat-form-field>
      </div>
    </div>
    @if (!data.citeDuty.isTemplate) {
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Team</mat-label>
          <mat-select placeholder="Team" [(ngModel)]="data.citeDuty.teamId">
            @if (!data.citeDuty.id && data.teamList.length > 1) {
            <mat-option value="">All Teams</mat-option>
            }
            @for (team of data.teamList; track team) {
            <mat-option [value]="team.id">
              {{ team.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }
  </div>
  }
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()" style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
